module.exports = __webpack_public_path__ + "img/icon-experiences.04dd8bb5.svg";